<template>
  <content-editor
    permission="branch"
    :fields="fields"
    endpoint="branch"
    module="branch">
  </content-editor>
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  data() {
    return {
      module: 'branch',
      fields: [
        {
          name: 'name',
          required: true,
        },
        {
          name: 'lightbox',
          required: false,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'tags',
          required: false,
        },
        {
          name: 'targets',
          required: true,
        },
        { name: 'image',
          required: true,
        },
        {
          name: 'online',
          required: true,
        },
        {
          name: 'seo_keywords',
          required: false,
        },
      ],
    };
  },
  components: {
    ContentEditor,
  },
};
</script>
